import { P2GGrid, P2GBox } from '@parcel2go/core-ui';
import { ReactNode } from 'react';
import { AnimatedAppCard } from '~/components/card/animated-border';
import { AppCard } from '~/components/card/app-card';

export const ActionWrapper = ({
  children,
  index,
  fade,
  prompts,
  isActive,
  type
}: {
  children: ReactNode;
  index: number;
  prompts: number;
  fade: boolean;
  isActive: boolean;
  type?: 'CONCERN' | 'BOOK' | undefined;
  isReady?: boolean;
}) => (
  <P2GGrid item xs={12} sm={prompts <= 2 ? 6 : 4}>
    <P2GBox
      sx={{
        opacity: fade ? 0.3 : 1,
        scale: fade ? 0.9 : 1,
        transition: '0.6s all ease-in-out'
      }}
    >
      {index === 0 || isActive ? (
        <AnimatedAppCard active={isActive}>
          <AppCard
            variant={type === 'CONCERN' ? 'warning' : isActive ? undefined : type === 'BOOK' ? 'success' : undefined}
          >
            <P2GBox
              p={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{ minHeight: { md: '95px', lg: 'auto' } }}
            >
              {children}
            </P2GBox>
          </AppCard>
        </AnimatedAppCard>
      ) : (
        <AppCard>
          <P2GBox
            p={2}
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ minHeight: { md: '95px', lg: 'auto' } }}
          >
            {children}
          </P2GBox>
        </AppCard>
      )}
    </P2GBox>
  </P2GGrid>
);
